import React, { useContext, useState } from "react";
import { ModalServiceContext, RicosContext } from "./../../../ricos-context";
import { getIsModalOpen, useModalState } from "./../../../ricos-modals/modal-service-provider";
import { DropdownButton } from "../../components";
import { alignmentMap, getDefaultAlignment } from "./utils";
const NodeAlignmentButton = ({ toolbarItem, dataHook, id }) => {
  const { t, languageDir, isMobile } = useContext(RicosContext) || {};
  const modalService = useContext(ModalServiceContext) || {};
  const isModalOpen = useModalState(getIsModalOpen(id));
  const [referenceElement, setReferenceElement] = useState(null);
  const getSelectedAlignment = () => toolbarItem?.attributes.nodeAlignment || getDefaultAlignment(languageDir);
  const getSelectedTextWrap = () => toolbarItem?.attributes.nodeTextWrap ?? true;
  const selectedAlignment = getSelectedAlignment();
  const SelectedAlignmentIcon = alignmentMap[`${selectedAlignment}`];
  const closeModal = () => modalService.closeModal(id);
  const onAlignmentClick = (alignment) => {
    toolbarItem.commands?.setAlignment({ value: alignment });
    closeModal();
  };
  const onTextWrapToggle = () => {
    toolbarItem.commands?.toggleTextWrap();
  };
  const isTextWrapDisabled = () => {
    return !toolbarItem.commands?.canToggleTextWrap();
  };
  const onClick = () => {
    modalService.isModalOpen(id) ? closeModal() : modalService?.openRegisteredModal(id, {
      componentProps: {
        getSelectedAlignment,
        getSelectedTextWrap,
        onClick: onAlignmentClick,
        onTextWrapToggle,
        isTextWrapDisabled
      },
      layout: isMobile ? "drawer" : "toolbar",
      positioning: { referenceElement, placement: "bottom" },
      returnFocusOnDeactivate: true
    });
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: isModalOpen,
      onClick,
      setRef: setReferenceElement,
      Icon: SelectedAlignmentIcon,
      tooltip: t("TextAlignmentButton_Tooltip")
    }
  );
};
var NodeAlignmentButton_default = NodeAlignmentButton;
export {
  NodeAlignmentButton_default as default
};
//# sourceMappingURL=NodeAlignmentButton.js.map
